import { FormControl, TextField } from "@mui/material";
import { ChangeEvent } from "react";

export interface IStringInputProps {
    label: string;
    value: string | null;
    multiline? : boolean | undefined;
    onChange: (value: string) => void;
}

export function StringInput(props: IStringInputProps) {
    const handleChange = (event:ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        props.onChange(value);
    }

    return (
        <FormControl onClick={(event) => {event.stopPropagation()}} fullWidth={props.multiline !== undefined}>
            <TextField
                multiline={props.multiline}
                fullWidth = {props.multiline !== undefined}
                type="string"
                label={props.label}
                variant="standard"
                value={props.value  ?? ''}
                onChange={handleChange}>
                    {props.value}

            </TextField>
        </FormControl>
    )
}